// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"99373b34","940":"40036d31"}[chunkId] + ".chunk.js";
};